import React, { useState } from "react";
import "./register.css";
import { Container, Spinner } from "react-bootstrap";
import { TextField } from "@mui/material";
import emailjs from "@emailjs/browser";
import InstallPWAButton from "../../InstallPWAButton/InstallPWAButton";
import { Fade, Zoom } from "react-awesome-reveal";
import notify from "../../Notifcation";
// import { createNewUserAction } from "../../../redux/actions/AuthAction";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import {
  createNewUserAction,
  getLoggedUserAction,
} from "../../../redux/actions/AuthAction";
// import { UpdateOneFileAction } from "../../../redux/actions/FileAction";
const Register = () => {
  const [passwordInput, setPasswordInput] = useState("");
  const [passwordconfirmInput, setpasswordconfirmInput] = useState("");
  const [Name, setName] = useState("");
  const [Phone, setPhone] = useState("");
  const [Agree, setAgree] = useState(false);
  const [Passwordp, setPasswordp] = useState("password");
  const [Passwordc, setPasswordc] = useState("password");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const togglep = () => {
    if (Passwordp === "password") {
      setPasswordp("text");
      return;
    }
    setPasswordp("password");
  };
  const togglec = () => {
    if (Passwordc === "password") {
      setPasswordc("text");
      return;
    }
    setPasswordc("password");
  };
  // const validationValues = () => {
  //   if (
  //     Name === "" ||
  //     Phone === "" ||
  //     passwordInput === "" ||
  //     passwordconfirmInput === ""
  //   ) {
  //     notify("من فضلك ادخل البيانات ", "error");
  //     return;
  //   }
  //   if (Phone.length <= 10) {
  //     notify("يجب ادخال رقم هاتف صحيح", "error");
  //     return;
  //   }
  //   if (passwordconfirmInput !== passwordInput) {
  //     notify("يجب ان تكون كلمة السر متطابقة", "error");
  //     return;
  //   }
  //   if (Agree === false) {
  //     notify("يجب الموافقة على سياسة الخصوصية ", "error");
  //     return;
  //   }
  // };
  const sendEmail = () => {
    emailjs
      .send(
        "service_miry0e7",
        "template_fa25byc",
        {
          name: Name,
          phoneNumber: Phone,
        },
        "XvO8s0zbcgmjO7eMH"
      )
      .then(
        (result) => {},
        (error) => {}
      );
  };
  const handlesubmit = async (e) => {
    if (
      Name === "" ||
      Phone === "" ||
      passwordInput === "" ||
      passwordconfirmInput === ""
    ) {
      notify("من فضلك ادخل البيانات ", "error");
      return;
    }
    if (Phone.length <= 10) {
      notify("يجب ادخال رقم هاتف صحيح", "error");
      return;
    }
    if (passwordconfirmInput !== passwordInput) {
      notify("يجب ان تكون كلمة السر متطابقة", "error");
      return;
    }
    if (Agree === false) {
      notify("يجب الموافقة على سياسة الخصوصية ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      createNewUserAction({
        name: Name,
        phoneNumber: Phone,
        password: passwordInput,
      })
    );

    setLoading(false);
    setIsPress(false);
  };
  const res = useSelector((state) => state.authReducer.createUser);
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (res.data && res.data.Token) {
            localStorage.setItem("tokenajindamuhami", res.data.Token);
            dispatch(getLoggedUserAction());
            notify("تم تسجيل الدخول بنجاح", "success");
            sendEmail();
            // setTimeout(() => {
            //   if (res.data.roleName === "admin") {
            //     window.location.href = "/admin";
            //   } else {
            //     window.location.href = "/user/mainuserpage";
            //   }
            // }, 2000);
          } else if (
            res.data &&
            res.data.ResponseMessage === "This phone number is already exist"
          ) {
            notify("هذا الرقم مسجل من قبل", "error");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.ResponseMessage) {
          //   notify("هذا الرقم مسجل من قبل", "error");
          // } else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  const resCurrnt = useSelector((state) => state.authReducer.currentUser);

  useEffect(() => {
    // if (loading === false) {
    if (localStorage.getItem("tokenajindamuhami") !== null) {
      localStorage.setItem("userajindamuhami", JSON.stringify(resCurrnt));
      if (resCurrnt) {
        if (resCurrnt.RoleName === "User") {
          setTimeout(() => {
            window.location.href = "/user/mainuserpage";
          }, 1500);
        }
        if (resCurrnt.RoleName === "SubUser") {
          setTimeout(() => {
            window.location.href = "/user";
          }, 1500);
        }
        if (resCurrnt.RoleName === "Admin") {
          setTimeout(() => {
            window.location.href = "/admin";
          }, 1500);
        }
        if (resCurrnt.RoleName === "Editor") {
          setTimeout(() => {
            window.location.href = "/editor";
          }, 1500);
        }
      }
    }
    // }
  }, [resCurrnt]);
  // useEffect(() => {
  //   if (loading === false) {
  //   if (localStorage.getItem("tokenajindamuhami")!==null) {
  //       const dat=  JSON.parse(atob(localStorage.getItem("tokenajindamuhami").split('.')[1]))

  //       if (dat['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] === "user") {
  //         setTimeout(() => {
  //           window.location.href = `/user/main/${0}`;
  //         }, 1500);
  //       } else {
  //         setTimeout(() => {
  //         window.location.href = "/admin";
  //       }, 1500);

  //       }
  //     }
  //   }
  // }, [loading]);
  return (
    <div className="register">
      {" "}
      <Container>
        <div id="bar-progress" className="mt-5 mt-lg-0">
          <div className="step step-active">
            <h5 style={{ border: "3px solid blue" }}>تجربة مجانية</h5>
          </div>
          <div className="seperator"></div>
          <div className="step ">
            <h5 style={{ border: "3px solid yellow" }}>99 جنيه شهرياً</h5>
          </div>
          <div className="seperator"></div>
          <div className="step">
            <h5 style={{ border: "3px solid orange" }}>990 جنيه سنوياً</h5>
          </div>
        </div>
        <InstallPWAButton />

        <div className="main-reg">
          <div className="content-main">
            <Zoom triggerOnce="false">
              <h2>"تطبيق أعمال أجندة المحامي القضائية"</h2>
              <h3>
                أقوى تطبيق إلكتروني متخصص لتنظيم أجندة المحامي القضائية اليومية
                بداية من بيانات الموكلين والتوكيلات والدعاوي و أجندة المحامي
                القضائية و العمل الإداري <i className="fa-solid fa-check"></i>
              </h3>
            </Zoom>
            <Fade direction="right" triggerOnce="false">
              {" "}
              <h4 style={{ color: "rgb(62,191,190)" }}>
                بياناتك في أقصى درجات الأمان والسرية
              </h4>
              <h4>
                أفضل وأسهل تطبيق سحابي متخصص لتنظيم أجندة المحامي القضائية
                اليومية بداية من بيانات الموكلين والتوكيلات وأجندة المحامي
                القضائية والعمل الإداري
              </h4>{" "}
              <p>
                تطبيق أجندة المحامي القضائية يتيح لكم إمكانية إدارة القوائم
                المتنوعة داخل البرنامج (قائمة الموكلين، قائمة الخصوم، قائمة
                التوكيلات، قائمة جهات التوثيق، قائمة المحاكم، قائمة الدوائر،...)
                ويمكنكم اضافة البيانات داخل كل قائمة بتفاصيلها لسهولة الرجوع
                إليها في إي وقت وسهولة ودقة تنظيم العمل داخل البرنامج.
              </p>
            </Fade>

            <Fade direction="right" triggerOnce="false">
              <ul>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> تطبيق أجندة
                  المحامي القضائية يتيح لكم تسجيل كافة بيانات الموكلين وكذلك
                  كافة بيانات التوكيلات المختلفة وتنظيمها وترتيبها وعرضها بسهولة
                  ودقة وحفظ صورة من التوكيل وكذلك بيانات الخصوم وصفاتهم.
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i> يمكنكم تطبيق
                  أعمال أجندة المحامي القضائية من إدخال بيانات الدعاوى بأنواعها
                  المختلفة مثل (الموكل وصفته والخصم وصفته، تاريخ رفع الدعوى،
                  ونوع الدعوي ورقمها المحكمة والدائرة، المستندات المقدمة في
                  الدعوى، وملخص للدعوى) ، كما يتيح لكم البرنامج إمكانية عرض كل
                  الدعاوي وسهولة البحث عن أي دعوى باسم الموكل أو صفته أو الخصم
                  أو بنوع الدعوى أو رقمها أو المحكمة.
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i> يمكنكم التطبيق من
                  إدخال بيانات أجندة المحامي القضائية مثل (تاريخ الجلسة والمحكمة
                  ورقم الدائرة ونوع الدعوى ورقم الدعوى واسم الموكل وصفته واسم
                  الخصم وصفته،والقرار و تاريخ الجلسة القادمة)
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  يمكنكم التطبيق من البحث في كافة بيانات أجندة المحامي القضائية
                  للوصول لكافة البيانات والتواريخ والقرارات بمنتهى السهولة
                  والدقة مثل (تاريخ الجلسات الحالية والسابقة واللاحقة) كما يحتوي
                  التطبيق علي تنبية بمواعيد وتاريخ الجلسات القادمة
                  قبل معادها بيومين
                </li>
                <li>
                  {" "}
                  <i className="fa-solid fa-chevron-left"></i>
                  يمكنكم التطبيق من إدخال بيانات الأعمال الإدارية مما يتيح لكم
                  إمكانية متابعة العمل الإداري اليومي من خلال آجندة العمل
                  الإداري بإضافة المهام والأعمال المطلوب القيام بأدائها يوميا
                  وماتم تنفيذه منها وأي ملاحظات آخري 
                </li>
              </ul>
            </Fade>
          </div>
          <div className="register-container">
            <h2>إنشاء حساب جديد</h2>
            <div className="register">
              <TextField
                style={{ borderColor: "blueviolet" }}
                label="اسم المستخدم"
                variant="outlined"
                inputProps={{ maxLength: 120 }}
                type="text"
                onChange={(e) => setName(e.target.value)}
                value={Name}
              />
              <TextField
                label="رقم الهاتف"
                variant="outlined"
                inputProps={{ maxLength: 15 }}
                type="number"
                value={Phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <TextField
                label="كلمة المرور"
                variant="outlined"
                value={passwordInput}
                onChange={(e) => setPasswordInput(e.target.value)}
                type={Passwordp}
              />
              <button className="btn btn-primary e" onClick={togglep}>
                {Passwordp === "password" ? (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16">
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                  </svg>
                )}
              </button>

              <TextField
                label="تأكيد كلمة المرور"
                variant="outlined"
                onChange={(e) => setpasswordconfirmInput(e.target.value)}
                type={Passwordc}
                value={passwordconfirmInput}
              />
              <button className="btn btn-primary c" onClick={togglec}>
                {Passwordc === "password" ? (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16">
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z" />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="17"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                  </svg>
                )}
              </button>
              <div className="agree">
                <input
                  type="checkbox"
                  onChange={(e) => setAgree(e.target.checked)}
                  checked={Agree}
                />
                <p>
                  <Link to={"/privacy"}>الشروط وسياسة الخصوصية </Link>
                </p>
              </div>
              {isPress && loading ? (
                <button
                  style={{ height: "50px", width: "211px", margin: "0 auto" }}>
                  <Spinner animation="border" role="status"></Spinner>
                </button>
              ) : (
                <button
                  style={{ height: "50px", width: "211px", margin: "0 auto" }}
                  onClick={handlesubmit}>
                  انشاء حساب مجاني
                </button>
              )}

              <div className="social">
                <a href="https://www.facebook.com/ajindamuhami/">
                  <i className="fa-brands fa-facebook"></i>
                </a>
                <a href="https://www.youtube.com/watch?v=5RwRC7tdlpk&list=PL-6EWK16rlYQ5elA3JXFb7tiedP5zG7jq">
                  <i
                    style={{ color: "#fff" }}
                    className="fa fa-brands fa-youtube"></i>
                </a>
              </div>

              <Link to="/login" style={{ color: "blue" }}>
                تسجيل الدخول{" "}
              </Link>
            </div>

            <h5 className="text-center wtsus">
              <a style={{ color: "#fff" }} href="https://wa.me/+201001122424">
                {" "}
                تواصل معنا واتساب
              </a>
              <b>
                {" "}
                <i
                  className="fa-brands fa-whatsapp"
                  style={{ color: "#fff" }}></i>
              </b>
            </h5>
          </div>
        </div>
      </Container>
      <ToastContainer autoClose={1200} />
    </div>
  );
};

export default Register;
